import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#visa-paint0_linear_2249_1709)",
      d: "M17.445 8.623a5 5 0 0 0-1.74-.301c-1.92 0-3.275.968-3.285 2.355-.012 1.02.964 1.594 1.701 1.936.757.35 1.01.57 1.008.885-.005.477-.605.693-1.162.693-.766 0-1.186-.107-1.831-.375l-.239-.111-.271 1.598c.466.195 1.306.362 2.175.375 2.041 0 3.375-.961 3.391-2.439.016-.813-.51-1.43-1.621-1.938-.674-.33-1.094-.551-1.094-.886 0-.296.359-.612 1.109-.612a3.6 3.6 0 0 1 1.455.273l.18.081.271-1.544zm4.983-.17h-1.5c-.467 0-.816.127-1.021.591l-2.885 6.534h2.041l.408-1.07 2.49.002c.061.25.24 1.068.24 1.068H24zM9.66 8.393h1.943l-1.215 7.129H8.444L9.66 8.391zm-4.939 3.929.202.99 1.901-4.859h2.059l-3.061 7.115H3.768l-1.68-6.026a.4.4 0 0 0-.18-.237A8.2 8.2 0 0 0 0 8.598l.025-.15h3.131c.424.016.766.15.883.604l.682 3.273zm15.308.727.775-1.994c-.01.02.16-.412.258-.68l.133.615.449 2.057h-1.615z"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "visa-paint0_linear_2249_1709",
        x1: "24",
        x2: "1",
        y1: "8",
        y2: "8",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#002898" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#11185C"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }